export const CAMERA_TYPE_ENUM = {
    TOP: "TOP",
    FRONT: 'FRONT'
}